import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'
import { FC } from 'react'
import { IMultiStageModalContent } from '../interfaces/IMultiStageModalContent'

interface IProps {
  isOpen: boolean
  onClose: () => void
  content: Record<string, IMultiStageModalContent>
  currentStep: string
  scrollBehaviour?: 'inside' | 'outside'
}

const MultiStageModal: FC<IProps> = ({
  content,
  isOpen,
  onClose,
  currentStep,
  scrollBehaviour = 'inside'
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={{ base: 'lg', md: 'xl' }}
      scrollBehavior={scrollBehaviour}
      isCentered
    >
      <ModalOverlay />
      <ModalContent mx={5}>
        <ModalHeader></ModalHeader>
        <ModalCloseButton
          onClick={() => {
            if (content[currentStep].onDismiss !== undefined) {
              // @ts-ignore
              content[currentStep].onDismiss()
            }
            onClose()
          }}
        />
        <ModalBody>
          <Box pt={4} px={1}>
            {content[currentStep].body}
          </Box>
        </ModalBody>
        <ModalFooter>{content[currentStep].footer}</ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default MultiStageModal
